module.exports = __webpack_public_path__ + "img/ChaLean.8a6b9762.jpeg";